'use strict';

var ConfirmationModalDirective = function ConfirmationModalDirective($compile, $rootScope) {
  var templates = {
    'soft-limit': require('../templates/soft-limit-confirmation.html'),
    'delete-limit': require('../templates/delete-limit-notification.html'),
    'delete-item': require('../templates/delete-item-confirmation.html')
  };
  return {
    restrict: 'A',
    scope: {},
    link: function link($scope, $element) {
      var opened = false;
      $scope.$on('confirmation:show', function (event, type, applicableSoftLimit, hepType) {
        if (!opened) {
          $scope.applicableSoftLimit = applicableSoftLimit;
          $scope.hepType = hepType;
          var el = $compile(templates[type])($scope);
          $scope.type = type;
          $element.empty().append(el);
          $element.find('.modal').modal('show');
          opened = true;
        }
      });
      var toggle = function toggle(res) {
        $element.find('.modal').modal('hide');
        opened = false;
        $rootScope.$broadcast('confirmation:' + $scope.type + ':result', res);
      };
      $scope.yes = toggle.bind(undefined, true);
      $scope.no = toggle.bind(undefined, false);
    }
  };
};
ConfirmationModalDirective.$inject = ['$compile', '$rootScope'];
module.exports = ConfirmationModalDirective;